'use client';
import ArrowRight from '@/assets/icons/ArrowRight.svg';
import CDNImage from '@/components/cdnImage/cdnImage';
import JumpLink from '@/components/JumpLink';
import JDIPrice from '@/components/price';
import JDIProductCardV2 from '@/components/productCard/components/type1';
import { useTranslation } from '@/i18n/client';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import style from './style.module.scss';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import pageSDK from '@/utils/goToPage';

export default function Module({
  moduleData,
  pageName,
  localInfo,
}: {
  moduleData: any;
  pageName: string;
  localInfo: any;
}) {
  const { t } = useTranslation();
  const pageConfig: any = {};
  const initConfig = (moduleData: any) => {
    pageConfig.data = moduleData.dataBatch?.productPool[0].productPool || [];
    pageConfig.title = moduleData.dataBatch?.productPool[0].title || '';
    pageConfig.jumpParams = moduleData.dataBatch?.productPool[0].pageSelection;
  };
  initConfig(moduleData);

  // JumpLink 跳转逻辑
  const JumpType = {
    Code: 'page-code',
    Url: 'custom',
  };

  const getSkuIdFromUrl = (url: string): string | undefined => {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      if (pathname.startsWith('/dp/')) {
        return pathname.match(/\/(\d+)$/)?.[1];
      }
    } catch (error) {}
  };

  const handleJumpClick = (jumpParams: any) => {
    const jumpType = jumpParams?.jumpType;
    const jumpValue = jumpParams?.jumpValue;

    if (jumpType === JumpType.Code) {
      const href = `/cms/${jumpValue.pageCodeInfo?.pageCode}${uaParse().isInJoybuyApp ? '?hideTitle=true' : ''}`;
      window.location.href = href;
    } else if (jumpType === JumpType.Url) {
      if (uaParse().isInJoybuyApp) {
        const skuId = getSkuIdFromUrl(jumpValue.link);
        if (skuId) {
          // 如果在joybuyApp里跳商详页，则直接唤起原生商详页
          return pageSDK.goToProduct({ skuId });
        } else {
          window.location.href = jumpValue.link;
        }
      }
      window.location.href = jumpValue.link;
    }
  };

  if (!Array.isArray(pageConfig.data) || pageConfig.data.length === 0) {
    return null;
  }
  if (!pageConfig.data) {
    return null;
  }
  const realPriceJDIPriceParams = {
    symbolStyle: { fontSize: '12px' },
    integerStyle: { fontSize: '18px' },
    decimalPointStyle: { fontSize: '18px' },
    decimalPlaceStyle: { fontSize: '18px' },
  };

  // -------------- Product Data -------------------- //
  const getProductData = (product: any, index: number) => {
    return {
      type: '1',
      skuId: product.skuId,
      skuName: product?.skuName,
      skuImg: product?.imageUrl,
      realPrice: product?.realPrice,
      originalPrice: product?.originalPriceV2,
      originalPriceTips: product?.originalPriceDesc,
      currency: localInfo?.currencyCode || '',
      languageCode: localInfo?.languageCode || '',
      shouldShowCart: false,
      shouldShowSkuName: false,
      priority: index < 4,
      onClickProduct: () => {
        handleJumpClick(pageConfig.jumpParams);
      },
      spmTrackParams: genEventTrackingInfo(product, index),

      // -------------- styles-------------------- //
      containerStyle: {
        flex: 1,
        width: '100%',
        height: '100%',
        minWidth: '100px',
        minHeight: '150px',
        borderRadius: '8px',
        backgroundColor: '#F9F9F9',
      },
      skuImgStyle: {
        width: '92px',
        height: '92px',
        margin: '4px',
      },
      skuNameStyle: {
        marginTop: '8px',
        fontSize: '14px',
        lineHeight: '18px',
        whiteSpace: 'normal',
        height: '36px',
      },
      priceStyle: {
        marginTop: '8px',
        //@ts-ignore
        textAlign: 'center' as TextAlign,
      },
      realPriceJDIPriceParams: {
        containerStyle: {
          lineHeight: '18px',
          marginRight: '0px',
          marginBottom: '4px',
        },
      },
      originalPriceJDIPriceParams: {
        containerStyle: {
          fontSize: '12px',
          fontWeight: '500',
          lineHeight: '16px',
          height: '100%',
          color: '#888B94',
        },
      },
    };
  };
  const genJsonParam = (product: any, index: number) => {
    const json_param = {
      index: index,
      floor_name: pageConfig.title,
      Mini_Hp_Name: pageName || 'home',
    };
    return json_param;
  };
  const genEventTrackingInfo = (product: any, index: number) => {
    const spmTrackParams = {} as { [key: string]: any };
    const json_param = genJsonParam(product, index);
    const expConfig = {
      useClick: false,
      stay_duration: 0,
      repeated: false,
      area_rate: 0.01,
    };
    spmTrackParams['productClick'] = {
      spm: `a0145.b002244.c00002471.${index + 1}`,
      page_id: 'Mini_Hp',
      event_id: 'Home_Mini_Hp_Hotitem',
      json_param: json_param,
    };
    spmTrackParams['productExpConfig'] = {
      spm: `a0145.b002244.c00002471.${index + 1}`,
      page_id: 'Mini_Hp',
      event_id: 'Home_Mini_Hp_Hotitem_Expo',
      config: expConfig,
      json_param: json_param,
    };
    return spmTrackParams;
  };

  return (
    <div className={style['product-h5-floor']}>
      <div className={style.header}>
        <JumpLink jumpParams={pageConfig.jumpParams}>
          <div className={style.headerContainer}>
            <div className={style.title}>{pageConfig.title}</div>
            <div className={style.buttonContainer}>
              <div
                style={{ display: 'flex' }}
                data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                data-exp={JSON.stringify({
                  spm: 'a0145.b002244.c00002471.more',
                  page_id: 'Mini_Hp',
                  event_id: 'Home_Mini_Hp_Hotitem_More_Expo',
                  json_param: {
                    Mini_Hp_Name: pageName || 'home',
                  },
                })}
                onClick={(e) => {
                  spmTrackingUtils.spmClick({
                    spm: 'a0145.b002244.c00002471.more',
                    page_id: 'Mini_Hp',
                    event_id: 'Home_Mini_Hp_Hotitem_More',
                    target: e.target as HTMLElement,
                    json_param: JSON.stringify({
                      Mini_Hp_Name: pageName || 'home',
                    }),
                  });
                }}
              >
                <span>{t('newArrivals.viewMore')}</span>
              </div>
            </div>
            <div className={style.rightIcon}>
              <ArrowRight className={style.headerIcon} />
            </div>
          </div>
        </JumpLink>
      </div>
      <div className={style.product}>
        {pageConfig &&
          pageConfig?.data?.map((item: any, index: any) => {
            return (
              <JDIProductCardV2
                key={item.skuId}
                // @ts-ignore
                productData={getProductData(item, index)}
              />
            );
          })}
      </div>
    </div>
  );
}
